/* Dmytro-Claude 28.09.2026 - family products (exactly two option groups: Type + Size) open with nothing chosen.

   The server side (ss_nopre in snippets/kalis-product-template.liquid) renders no checked option, the product's own
   featured image, the Size row hidden, and a disabled button «Choose type & size». Only when the URL has no ?variant=.

   This script keeps that state until the customer has picked BOTH options:
   - a Type pick is held back from the theme's variant engine (theme.Variants in kalis-theme.js). With dynamic variants
     on, the engine would complete it to the closest available variant and check a size by itself;
   - instead we show the Size row, mark the sizes that are sold out for that type, move the gallery to the type's image
     (the theme's own variantImageChange event, which changes the slide but not the variant) and update the heading and
     the button text («Choose size»);
   - the size filter in assets/variant-filter-proxy.js already hides the sizes of other types and, while [data-ss-nopre]
     exists, does not pick a size either;
   - once both options are checked the change event goes through untouched and the theme takes over as on any product;
     the «from €X» price the server rendered is replaced with the chosen variant's price at that moment. */
(function () {
  'use strict';
  var flag = document.querySelector('[data-ss-nopre]');
  if (!flag || flag.dataset.ssReady) return;
  flag.dataset.ssReady = '1';

  var root = flag.closest('[data-section-type="product"]') || document;
  var form = document.getElementById(flag.getAttribute('data-form'));
  var btn = form && form.querySelector('[data-add-to-cart]');
  var json = root.querySelector('[data-variant-json]');
  var variants = [];
  try { variants = JSON.parse(json.textContent); } catch (e) { return; }

  var chooseBoth = flag.getAttribute('data-choose-both') || '';
  var chooseSize = flag.getAttribute('data-choose-size') || '';
  var inStock = flag.getAttribute('data-in-stock') || '';

  function group(i) { return root.querySelector('.variant-input-wrap[data-index="option' + i + '"]'); }
  function checked(i) {
    var g = group(i);
    var r = g && g.querySelector('input[type="radio"]:checked');
    return r ? r.value : null;
  }

  function setHeading(i, value) {
    var g = group(i);
    var out = g && g.closest('.variant-wrapper').querySelector('[data-ss-opt-value]');
    if (out) out.textContent = value ? value.replace(/^Overall\s+/, '') : '';
  }

  function setButton() {
    if (!btn) return;
    // The Size row only opens once a Type is picked, so there are two states: nothing chosen, or Type chosen
    var text = btn.querySelector('[data-add-to-cart-text]');
    var label = checked(1) ? chooseSize : chooseBoth;
    if (text && label) text.textContent = label;
    btn.disabled = true;
  }

  // Sizes that exist but are sold out for the chosen type get the theme's crossed-out look (still clickable, as in the theme)
  function markSizes(type) {
    var g = group(2);
    if (!g) return;
    g.querySelectorAll('.variant-input').forEach(function (el) {
      var value = el.getAttribute('data-value');
      var ok = variants.some(function (v) { return v.option2 === value && v.available && (!type || v.option1 === type); });
      el.querySelectorAll('input, label').forEach(function (n) { n.classList.toggle('disabled', !ok); });
    });
  }

  function showTypeImage(type) {
    var v = variants.find(function (x) { return x.option1 === type && x.available && x.featured_media; })
         || variants.find(function (x) { return x.option1 === type && x.featured_media; });
    if (v) root.dispatchEvent(new CustomEvent('variantImageChange', { detail: { variant: v } }));
  }

  // On load the theme resolves an empty selection to the first available variant and writes that variant's stock
  // («Only 2 left») into the stock line. Put the neutral line back until a real variant is chosen.
  function resetStock() {
    var inv = root.querySelector('[data-product-inventory]');
    if (inv) {
      if (inStock) inv.textContent = inStock;
      var box = inv.closest('.icon-and-text');
      if (box) box.classList.remove('inventory--low');
    }
    var incoming = root.querySelector('[data-incoming-inventory]');
    if (incoming) incoming.classList.add('hide');
  }

  var active = true;

  document.addEventListener('change', function (e) {
    if (!active) return;
    var t = e.target;
    if (!t || !t.matches || !t.matches('[data-variant-input]') || !root.contains(t)) return;

    if (checked(1) && checked(2)) {
      // Both chosen: hand over to the theme (variant, price, image, stock, button, ?variant= in the URL)
      active = false;
      flag.removeAttribute('data-ss-nopre');
      // The price line still says «from €X». The theme only rewrites it when the new variant's price differs from the
      // variant it resolved on load (theme.Variants._updatePrice), so push the chosen variant's price once, after the
      // theme has handled this change and settled on the final variant
      setTimeout(function () {
        var o1 = checked(1), o2 = checked(2);
        var v = variants.find(function (x) { return x.option1 === o1 && x.option2 === o2; });
        if (v) root.dispatchEvent(new CustomEvent('variantPriceChange', { detail: { variant: v } }));
      }, 0);
      return;
    }

    // Only one chosen: keep it away from the theme's engine and the other change listeners
    e.stopPropagation();
    var i = t.dataset.index === 'option1' ? 1 : 2;
    setHeading(i, t.value);
    if (i === 1) {
      var later = root.querySelector('[data-ss-nopre-later]');
      if (later) { later.style.display = ''; later.removeAttribute('data-ss-nopre-later'); }
      markSizes(t.value);
      showTypeImage(t.value);
    }
    setButton();
  }, true);

  function init() {
    if (!active) return;
    markSizes(checked(1));
    resetStock();
    setButton();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(init, 0); });
  else setTimeout(init, 0);
  window.addEventListener('load', init);
})();
